import React from 'react';
import { Popover } from '@material-ui/core';
import type { PopoverOrigin, Theme } from '@material-ui/core';

import { useKlpStyles } from '../Theme';

type KlpPopoverProps = {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    anchorOrigin?: PopoverOrigin;
};

const styles = (theme: Theme) => ({
    popover: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
    },
});

export const KlpPopover = ({
    anchorEl,
    open,
    onClose,
    children,
    anchorOrigin,
}: KlpPopoverProps) => {
    const classes = useKlpStyles({}, styles);
    return (
        <Popover
            PaperProps={{
                className: classes.popover,
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={
                anchorOrigin || {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            }
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            {children}
        </Popover>
    );
};
